import { Input } from '@/components/ui/input';
import { useState } from 'react';
import { IoIosArrowDown } from "react-icons/io";
import { MdKeyboardArrowDown } from 'react-icons/md';

const ServiceSelectSearchBox = ({ services, setServiceUpdateInfo, name }) => {
    const [searchTerm, setSearchTerm] = useState(name || '');
    const [isOpen, setIsOpen] = useState(false);

    const filteredOptions = services.filter((service) =>
        service?.serviceId?.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
        setIsOpen(true);
    };

    const handleOptionClick = (service) => {
        setSearchTerm(service?.serviceId?.name);
        setServiceUpdateInfo((prev) => ({ ...prev, serviceId: service?._id }));
        setIsOpen(false);
    };

    return (
        <div className="w-full relative">
            <div className='relative flex justify-between'>
                <Input
                    type="text"
                    value={searchTerm}
                    onChange={handleInputChange}
                    placeholder="Search..."
                />
                <MdKeyboardArrowDown onClick={() => setIsOpen(!isOpen)} className="absolute top-2 right-2 text-gray-500" size={22} />
            </div>
            {isOpen && (
                <div className="mt-1 w-full bg-white border border-gray-300 max-h-[200px] overflow-y-auto shadow-md">
                    {filteredOptions.map((service) => (
                        <div
                            key={service?.serviceId?._id}
                            className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() => handleOptionClick(service)}
                        >
                            {service?.serviceId?.name}
                        </div>
                    ))}
                    {filteredOptions.length === 0 && <p className='px-2 py-1'>No services available.</p>}
                </div>
            )}
        </div>
    );
};

export default ServiceSelectSearchBox;
